module.exports = __webpack_public_path__ + "static/img/4.1d1bf87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/snip3down/4.png
// module id = uVhk
// module chunks = 35